import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cards: {
    height: 'auto',
    display: 'none',
    background: '#FFF',
    justify: 'space-between',
    padding: '12px 16px',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  logoWrapper: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    paddingRight: 16,
  },
  logo: {
    width: '100%',
    maxHeight: 40,
    objectFit: 'contain',
    objectPosition: 'left center',
  },
  logoContainer: {
    maxWidth: 200,
    height: 'auto',
  },
  contentContainer: {},
  progress: {
    textAlign: 'right',
    color: theme.palette.secondary.dark,
  },
  name: {
    textAlign: 'right',
    color: theme.palette.common.black,
  },
}))
